import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const samKvsSearchSliceName = "samKvsSearch";

export interface SamKvsSearchState {
  partKeyExternal: string | undefined;
}

const initialState: SamKvsSearchState = {
  partKeyExternal: undefined,
};

const samSlice = createSlice({
  name: samKvsSearchSliceName,
  initialState,
  reducers: {
    setKvsSearchPartKeyExternal(state: SamKvsSearchState, action: PayloadAction<string | undefined>) {
      state.partKeyExternal = action.payload;
    },
  },
});

export interface SamKvsSearchRootState {
  [samKvsSearchSliceName]: SamKvsSearchState;
}

export const selectSamKvsSearch = (state: SamKvsSearchRootState) => state[samKvsSearchSliceName];
export const selectSamKvsSearchPartKeyExternal = (state: SamKvsSearchRootState) => {
  return selectSamKvsSearch(state).partKeyExternal;
};

export const { setKvsSearchPartKeyExternal } = samSlice.actions;
export const samKvsReducer = samSlice.reducer;
